import { BreadCrumbElement } from './BreadCrumbElement';
import { StyledBreadCrumb } from './style';

import type React from 'react';
import type { BreadCrumbElementProps } from './BreadCrumbElement';

export type BreadCrumbProps = {
  values: BreadCrumbElementProps[];
};

export const BreadCrumb: React.FC<BreadCrumbProps> = ({ values }) => (
  <StyledBreadCrumb className="breadcrumb-wrapper">
    <ul className="breadcrumb">
      {values.map((value) => (
        <BreadCrumbElement key={value.text} {...value} />
      ))}
    </ul>
  </StyledBreadCrumb>
);
